export default __webpack_public_path__ + "static/media/about_rectangle_3.21c6ca4d.svg";